import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
const Languages = ["en", "ar", "fr", "in"];
i18n

  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    whitelist: Languages,

    // Translation files are deployed as public files with stable URLs. Do not
    // allow a browser to reuse an older file after new translation keys are
    // released, otherwise i18next displays the key (for example, "part4").
    backend: {
      requestOptions: {
        cache: "no-store",
      },
    },

    interpolation: {
      escapeValue: false,
    },
  });
export default i18n;
